// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import FitTextToBounds from "../../components/core/FitTextToBounds";
import LocaliseText from "../../components/core/LocaliseText";
import BtnReplayEnd from "../btns/BtnReplayEnd";
import BtnNextLevel from "../btns/BtnNextLevel";
import BtnHomeEnd from "../btns/BtnHomeEnd";
/* START-USER-IMPORTS */
import { TransitionPoint } from '../../app-routing';
import UIButton from '../../components/core/UIButton';
import { Sounds } from '../../sounds';
import GameUI from '../../scenes/GameUI';
import { GameDataHandler } from '../../game/GameDataHandler';
import { RunSettingsHandler } from '../../game/RunSettingsHandler';
import { LevelNameValues } from '../../game/levels/level';
import { LevelUtil } from '../../game/levels/LevelUtil';

/* END-USER-IMPORTS */

export default class EndScreen extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 768);
    cover.visible = false;
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    this.add(cover);

    // screen
    const screen = scene.add.container(0, -106);
    this.add(screen);

    // arm
    const arm = scene.add.sprite(-4, -246, "endscreen", "popup-arm.png");
    screen.add(arm);

    // panelBG
    const panelBG = scene.add.sprite(0, 86, "endscreen", "popup-complete-box.png");
    screen.add(panelBG);

    // bestScoreBox
    const bestScoreBox = scene.add.image(-4, 242, "endscreen", "popup-hiscore-box.png");
    screen.add(bestScoreBox);

    // bestScoreBox_1
    const bestScoreBox_1 = scene.add.image(-67, 241, "endscreen", "popup-hiscore-trophy.png");
    screen.add(bestScoreBox_1);

    // bestScoreText
    const bestScoreText = scene.add.text(34, 240, "", {});
    bestScoreText.setOrigin(0.5, 0.5);
    bestScoreText.text = "100";
    bestScoreText.setStyle({ "fontFamily": "Acme-Regular", "fontSize": "50px" });
    screen.add(bestScoreText);

    // scoreBox
    const scoreBox = scene.add.image(-5, 103, "endscreen", "popup-score-box.png");
    screen.add(scoreBox);

    // endScoreText
    const endScoreText = scene.add.text(-6, 97, "", {});
    endScoreText.setOrigin(0.5, 0.5);
    endScoreText.text = "0";
    endScoreText.setStyle({ "align": "center", "fontFamily": "Acme-Regular", "fontSize": "80px" });
    screen.add(endScoreText);

    // starBackground1
    const starBackground1 = scene.add.image(-156, -48, "endscreen", "popup-star-holder.png");
    starBackground1.scaleX = 0.9;
    starBackground1.scaleY = 0.9;
    starBackground1.angle = -6.000000000000001;
    screen.add(starBackground1);

    // starBackground2
    const starBackground2 = scene.add.image(-5, -69, "endscreen", "popup-star-holder.png");
    screen.add(starBackground2);

    // starBackground3
    const starBackground3 = scene.add.image(144, -47, "endscreen", "popup-star-holder.png");
    starBackground3.scaleX = 0.9;
    starBackground3.scaleY = 0.9;
    starBackground3.angle = 6.000000000000001;
    screen.add(starBackground3);

    // star1
    const star1 = scene.add.image(-155, -48, "endscreen", "popup-star.png");
    star1.scaleX = 0.9;
    star1.scaleY = 0.9;
    star1.angle = -6.000000000000001;
    screen.add(star1);

    // star2
    const star2 = scene.add.image(-4, -69, "endscreen", "popup-star.png");
    screen.add(star2);

    // star3
    const star3 = scene.add.image(145, -47, "endscreen", "popup-star.png");
    star3.scaleX = 0.9;
    star3.scaleY = 0.9;
    star3.angle = 6.000000000000001;
    screen.add(star3);

    // Title
    const title = scene.add.container(2, -196);
    screen.add(title);

    // titleBox
    const titleBox = scene.add.sprite(0, 0, "endscreen", "popup-heading-large.png");
    title.add(titleBox);

    // levelCompleteTitle
    const levelCompleteTitle = scene.add.text(0, 0, "", {});
    levelCompleteTitle.setOrigin(0.5, 0.5);
    levelCompleteTitle.text = "New text";
    levelCompleteTitle.setStyle({ "fontFamily": "Acme-Regular", "fontSize": "70px", "shadow.offsetY":3,"shadow.fill":true});
    levelCompleteTitle.setPadding({"left":10,"top":10,"right":10,"bottom":10});
    title.add(levelCompleteTitle);

    // taz
    const taz = scene.add.image(-475, 384, "endscreen", "taz-level-complete.png");
    taz.setOrigin(0.5, 1);
    this.add(taz);

    // teammate
    const teammate = scene.add.image(476, 384, "endscreen", "marvin-popup.png");
    teammate.setOrigin(0.5, 1);
    this.add(teammate);

    // Buttons
    const buttons = scene.add.container(0, 279);
    this.add(buttons);

    // btnReplayEnd
    const btnReplayEnd = new BtnReplayEnd(scene, 0, 0);
    buttons.add(btnReplayEnd);

    // btnNextEnd
    const btnNextEnd = new BtnNextLevel(scene, 178, 0);
    buttons.add(btnNextEnd);

    // btnHomeEnd
    const btnHomeEnd = new BtnHomeEnd(scene, -169, 0);
    buttons.add(btnHomeEnd);

    // lists
    const stars = [star1, star2, star3];
    const starBacks = [starBackground1, starBackground2, starBackground3];

    // bestScoreText (components)
    const bestScoreTextFitTextToBounds = new FitTextToBounds(bestScoreText);
    bestScoreTextFitTextToBounds.maxWidth = 100;
    bestScoreTextFitTextToBounds.constrainByWidth = true;

    // endScoreText (components)
    const endScoreTextFitTextToBounds = new FitTextToBounds(endScoreText);
    endScoreTextFitTextToBounds.maxWidth = 180;
    endScoreTextFitTextToBounds.constrainByWidth = true;

    // levelCompleteTitle (components)
    const levelCompleteTitleFitTextToBounds = new FitTextToBounds(levelCompleteTitle);
    levelCompleteTitleFitTextToBounds.maxWidth = 450;
    levelCompleteTitleFitTextToBounds.constrainByWidth = true;
    const levelCompleteTitleLocaliseText = new LocaliseText(levelCompleteTitle);
    levelCompleteTitleLocaliseText.copyId = "levelComplete";

    this.cover = cover;
    this.screen = screen;
    this.panelBG = panelBG;
    this.bestScoreBox = bestScoreBox;
    this.bestScoreBox_1 = bestScoreBox_1;
    this.bestScoreText = bestScoreText;
    this.scoreBox = scoreBox;
    this.endScoreText = endScoreText;
    this.starBackground1 = starBackground1;
    this.starBackground2 = starBackground2;
    this.starBackground3 = starBackground3;
    this.star1 = star1;
    this.star2 = star2;
    this.star3 = star3;
    this.titleBox = titleBox;
    this.levelCompleteTitle = levelCompleteTitle;
    this.taz = taz;
    this.teammate = teammate;
    this.buttons = buttons;
    this.btnReplayEnd = btnReplayEnd;
    this.btnNextEnd = btnNextEnd;
    this.btnHomeEnd = btnHomeEnd;
    this.stars = stars;
    this.starBacks = starBacks;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    this.newHighScore = false;
    /* END-USER-CTR-CODE */
  }

  private cover: Phaser.GameObjects.Rectangle;
  private screen: Phaser.GameObjects.Container;
  private panelBG: Phaser.GameObjects.Sprite;
  private bestScoreBox: Phaser.GameObjects.Image;
  private bestScoreBox_1: Phaser.GameObjects.Image;
  private bestScoreText: Phaser.GameObjects.Text;
  private scoreBox: Phaser.GameObjects.Image;
  private endScoreText: Phaser.GameObjects.Text;
  private starBackground1: Phaser.GameObjects.Image;
  private starBackground2: Phaser.GameObjects.Image;
  private starBackground3: Phaser.GameObjects.Image;
  private star1: Phaser.GameObjects.Image;
  private star2: Phaser.GameObjects.Image;
  private star3: Phaser.GameObjects.Image;
  private titleBox: Phaser.GameObjects.Sprite;
  private levelCompleteTitle: Phaser.GameObjects.Text;
  private taz: Phaser.GameObjects.Image;
  private teammate: Phaser.GameObjects.Image;
  private buttons: Phaser.GameObjects.Container;
  private btnReplayEnd: BtnReplayEnd;
  private btnNextEnd: BtnNextLevel;
  private btnHomeEnd: BtnHomeEnd;
  private stars: Phaser.GameObjects.Image[];
  private starBacks: Phaser.GameObjects.Image[];
  public screenStartY: number = -900;
  public characterStartY: number = 1300;
  public buttonStartY: number = -515;

  /* START-USER-CODE */
  private particleEmitter!: Phaser.GameObjects.Particles.ParticleEmitter;
  private endScore!: number;
  private highScore!: number;
  private earnedPoints!: number;
  private earnedStars: number = 2;
  private newHighScore: boolean;

  public awake() {
    this.cover.setInteractive();

    this.btnReplayEnd.once(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.Replay);
    });

    this.btnNextEnd.once(UIButton.events.clicked, () => {
      let currentLevel: LevelNameValues | undefined = GameDataHandler.getLastLevelPlayed(this.scene);
      let nextLevel: LevelNameValues | undefined = LevelUtil.getNextLevel(currentLevel!);

      if(nextLevel == undefined && !LevelUtil.isLastLevel(currentLevel!))
      {
        GameDataHandler.updateLastWorldPlayed(this.scene,GameDataHandler.getLastWorldPlayed(this.scene)+1);
      }

      if (nextLevel) this.scene.events.emit(GameUI.events.NextLevel, nextLevel);
      else this.scene.events.emit(GameUI.events.LevelSelect);
    });

    this.btnHomeEnd.once(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.LevelSelect);
    });

    this.particleEmitter = this.scene.make.particles({
      key: 'particles',
      config: {
        name: 'explode',
        emitting: false,
        frame: [ 'particle-star-pink.png','particle-star-red.png','particle-star-white.png','particle-star-yellow.png'],
        angle: { min: -200, max: 0 },
        rotate:{
          onEmit: (particle) => {
            return Phaser.Math.Between(0,360);
          },
          onUpdate: (particle) => {
            //make the particles face the direction of travel...
            return particle.angle + 1;
          },
        },
        scale: { start: 0.01, end: 2, ease: Phaser.Math.Easing.Cubic.Out },
        alpha: { start: 1, end: 0, ease: Phaser.Math.Easing.Cubic.In },
        speed: { min: 400, max: 900 },
        colorEase: 'quad.out',
        gravityY: 600,
        lifespan: 2000,
        quantity: 4
      }
    });

    this.add(this.particleEmitter);

  }

  public activate(endScore: number, highScore: number, earnedPoints: number, earnedStars: number, showNextLevel:boolean) {
    // endScore = 300;
    // highScore = 234;
    // earnedPoints = 10;
    // earnedStars = 3;

    this.endScore = Math.trunc(endScore);
    this.highScore = Math.trunc(highScore);
    this.earnedPoints = earnedPoints;
    this.earnedStars = earnedStars;

    if(!showNextLevel)
    {
      this.btnNextEnd.visible = false;
      this.btnReplayEnd.x = 86;
      this.btnHomeEnd.x = -86;
      LocaliseText.getComponent(this.levelCompleteTitle).changeText("gameComplete");
      this.titleBox.setTexture("endscreen","popup-heading-large-gold.png");
      this.scoreBox.setTexture("endscreen","popup-score-box-gold.png");
      this.bestScoreBox.setTexture("endscreen","popup-hiscore-box-gold.png");
      this.panelBG.setTexture("endscreen","popup-complete-box-gold.png");
      this.starBackground1.setTexture("endscreen","popup-star-holder-gold.png");
      this.starBackground2.setTexture("endscreen","popup-star-holder-gold.png");
      this.starBackground3.setTexture("endscreen","popup-star-holder-gold.png");
      this.btnHomeEnd.UIButton.shouldPulse = true;
      this.btnHomeEnd.UIButton.pulseBtn();
      this.taz.setTexture("endscreen","taz-game-complete.png");
    }

    this.newHighScore = false;
    if (this.endScore > this.highScore || this.highScore == 0) this.newHighScore = true;

    this.bestScoreText.setText(this.highScore.toString());

    this.transitionIn();

    this.teammate.setTexture(this.teammate.texture.key,"popup-"+GameDataHandler.getLastCharacterPlayed(this.scene).toLowerCase()+".png");
  }

  protected transitionIn() {
    let startDelay = 400;

    this.cover.alpha = 0;
    this.cover.visible = true;
    let screenFinishY = this.screen.y;
    this.screen.y = this.screenStartY;

  let buttonsFinishY = this.buttons.y;
  this.buttons.y = this.buttonStartY;

    let tazFinishY = this.taz.y;
    this.taz.y += this.taz.height;
    let teammateFinishY = this.teammate.y;
    this.teammate.y += this.teammate.height*2;

    for (const star of this.stars) {
      star.alpha = 0;
      star.scale = 0;
    }

    this.btnNextEnd.UIButton.pulseDelay = startDelay + 5500;

    let timeline = this.scene.add.timeline([
      {
        at: Math.max(0, startDelay - 100),
        run: () => {
          this.scene.add.tween({
            targets: this.cover,
            alpha: { from: 0, to: 1 },
            // duration: 300,
            delay: startDelay,
            ease: Phaser.Math.Easing.Cubic.InOut
          });
        }
      },
      {
        at: startDelay + 300,
        run: () => {
          this.scene.add.tween({
            targets: this.screen,
            y: { from: this.screenStartY, to: screenFinishY },
            duration: 500,
            ease: Phaser.Math.Easing.Back.Out,
            // delay: startDelay + 300,
            onStart: () => {
              this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.SndPartyHorn2, Sounds.Channel.SFX, { volume: 1.0 });
              this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.TazHappyYellandSlurp, Sounds.Channel.SFX, { volume: 2.0});
            },
            callbackScope: this
          });
        }
      },
    {
        at: startDelay + 300,
        run: () => {
          this.scene.add.tween({
            targets: this.buttons,
            y: { from: this.buttonStartY, to: buttonsFinishY },
            duration: 500,
            ease: Phaser.Math.Easing.Back.Out,
            // delay: startDelay + 300,
            callbackScope: this
          });
        }
      },
      {
        at: startDelay + 800,
        run: () => {
          this.particleEmitter.explode(100, 0, -120);
          this.scene.children.bringToTop(this.particleEmitter);
        }
      },
      {
        at: startDelay + 2750,
        run: () => {
          let endCounterTween = this.scene.tweens.addCounter({
            from: 0,
            to: this.endScore,
            duration: 2000,
            // delay: startDelay + 2750,
            ease: Phaser.Math.Easing.Linear,
            onUpdate: (tween, target, param) => {
              this.endScoreText.text = Math.floor(endCounterTween.getValue()).toString();
            },
            onComplete: () => {
              // this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.BonusPoints1, Sounds.Channel.SFX, { volume: 4 });
            }
          });
        }
      },
      {
        at: startDelay + 2800,
        run: () => {
          let starNum: number = 0;
          for (const star of this.stars) {
            if (starNum < this.earnedStars) {
              this.scene.add.tween({
                targets: star,
                alpha: 1,
                scale: starNum  == 1 ? 1 : 0.9,
                duration: 500,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: starNum * 400,
                onStart: () => {
                  this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.Star, Sounds.Channel.SFX, { volume: 1 });
                },
                callbackScope: this
              });
            }
            starNum++;
          }
        }
      },
      {
        at: startDelay + 5500,
        run: () => this.startIdles()
      },
      {
        at: startDelay + 5000,
        run: () => {
          if (this.newHighScore) {
            let bestTimeCounterTween = this.scene.tweens.addCounter({
              from: this.highScore,
              to: this.endScore,
              duration: 2000,
              // delay: startDelay + 5000,
              ease: Phaser.Math.Easing.Linear,
              onUpdate: (tween, target, param) => {
                this.bestScoreText.text = Math.floor(bestTimeCounterTween.getValue()).toString();
              },
              onComplete: () => {
                this.bestScoreText.setColor('#ffef00');
                this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.TazYeahYeahYeah, Sounds.Channel.SFX, { volume: 2.0});

                this.scene.add.tween({
                  targets: this.bestScoreText,
                  alpha: { from: 1, to: 0 },
                  duration: 500,
                  ease: Phaser.Math.Easing.Cubic.InOut,
                  repeat: 2,
                  yoyo: true,
                  delay: 250
                });
              }
            });
          }
        }
      },
      {
        at: startDelay + 600,
        run: () => {
          this.scene.add.tween({
            targets: this.taz,
            y: { from: this.taz.y + this.taz.height, to: tazFinishY },
            duration: 500,
            ease: Phaser.Math.Easing.Quadratic.InOut,
            // delay: startDelay + 300,
            callbackScope: this
          });
        }
      },
      {
        at: startDelay + 800,
        run: () => {
          this.scene.add.tween({
            targets: this.teammate,
            y: { from: this.teammate.y + this.teammate.height, to: teammateFinishY },
            duration: 500,
            ease: Phaser.Math.Easing.Quadratic.InOut,
            // delay: startDelay + 300,
            callbackScope: this
          });
        }
      }
    ]);

    timeline.play(true);
  }

  protected startIdles() {}

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
